const mobileRoutes = [
  {
    path: '/m',
    name: 'MobileHome',
    component: () => import('../views-mobile/Home.vue')
  },
  {
    path: '/m/about',
    name: 'MobileAbout',
    component: () => import('../views-mobile/About.vue')
  },
  {
    path: '/m/contact',
    name: 'MobileContact',
    component: () => import('../views-mobile/Contact.vue')
  },
  {
    path: '/m/founder',
    name: 'MobileFounder',
    component: () => import('../views-mobile/Founder.vue')
  },
  {
    path: '/m/product',
    name: 'MobileProductIndex',
    component: () => import('../views-mobile/product/Index.vue')
  },
  {
    path: '/m/product/:id',
    name: 'MobileProductDetail',
    component: () => import('../views-mobile/product/Detail.vue')
  },
  {
    path: '/m/user-info',
    name: 'MobileUserInfo',
    component: () => import('../views-mobile/userInfo.vue')
  },
  {
    path: '/m/account',
    name: 'MobileAccount',
    component: () => import('../views-mobile/Account.vue')
  },
  {
    path: '/m/enquiry',
    name: 'MobileEnquiry',
    component: () => import('../views-mobile/Enquiry.vue')
  },
  {
    path: '/m/enquiry-sub',
    name: 'MobileEnquirySub',
    component: () => import('../views-mobile/EnquirySub.vue')
  }
  
   
   // // 1. 所有旧的移动端路径重定向到 /m/index
   //    {
   //        path: '/m/about',
   //        redirect: '/m/index'
   //    },
   //    {
   //        path: '/m/contact',
   //        redirect: '/m/index'
   //    },
   //    {
   //        path: '/m/founder',
   //        redirect: '/m/index'
   //    },
   //    {
   //        path: '/m/product',
   //        redirect: '/m/index'
   //    },
   //    {
   //        path: '/m/product/:id',
   //        redirect: '/m/index'
   //    },
   //    {
   //        path: '/m/user-info',
   //        redirect: '/m/index'
   //    },
   //    {
   //        path: '/m/account',
   //        redirect: '/m/index'
   //    },
   //    {
   //        path: '/m/enquiry',
   //        redirect: '/m/index'
   //    },
   //    {
   //        path: '/m/enquiry-sub',
   //        redirect: '/m/index'
   //    },
      
   //    // 2. 移动端根路径重定向到 /m/index
   //    {
   //        path: '/m',
   //        redirect: '/m/index'
   //    },
      
   //    // 3. 唯一可访问的移动端页面
   //    {
   //        path: '/m/index',
   //        name: 'MobileIndex',
   //        component: () => import('../views-mobile/Index.vue')
   //    }
]

export default mobileRoutes
